<template>
  <div id="contendor-principal-consultaSentencias" style="position:relative;">
    <div id="contenedor-encabezados-consultasSentencias" class="text-left">
      <h1>SENTENCIAS</h1>
      <h3 style="color: black">Consulta de Sentencias</h3>
    </div>    
    <div class="row mt-3">
      <div id="contenedor-filtos-consulta" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12">                
        <div class="area" style="background-color:#bebebc">            
            <FiltrosDeBusqueda 
                :catalogos="catalogos" 
                :elementosAOmitir ="elementosAOmitir"
                :AccionesMostrar="AccionesFormulario"
                :ejecutaLaFuncion="buscarExpediente" 
                :ejecutalimpiarTablaResultados="limpiarTablaResultados"                
                :tituloDeBusqueda="'Búsqueda del expediente'"             
                :ref="'filtroBusqueda'">
            </FiltrosDeBusqueda>      
        </div>             
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 pt-4" id="ExpedientesEncontradosSentencias_div">
        <div v-bind:class="[(this.expediente == undefined || this.expediente == null || this.expediente.length <= 0) ? 'areaLocal' : 'areaLocal gris-claro']">
          <div v-if="(this.expediente == undefined || this.expediente == null || this.expediente.length <= 0)" style="background-color:var(--gris-pj-100); padding: 8px;">
            <div class="d-flex justify-content-center">
              <i class="fas fa-clipboard-list mr-sm-2" style="font-size: 25px;color:black"></i>
              <div class="align-content-center">
                <h5 style="color: black">Expedientes encontrados</h5>
              </div>
            </div>
          </div>
          
          <TablaDeResultados 
            v-if="expediente != undefined && expediente != null"
            v-show="!mostrarFormularioInformacionSentencia"
            v-on:valorParaElPadreAccion="accionRealizar"
            :AccionesMostrar="AccionesTabla"
            :Expedientes="expediente"
            :EsConsulta="true">
          </TablaDeResultados>

        </div>  
      </div> 
    </div>
    <VisorTesteoSentencia
      v-if="mostrarVisualizadorTesteoSentencia && EsBase64 != undefined && EsBase64 != null "
      :esTesteo="false"
      :esConsulta="true"      
      :EsBase64="EsBase64"
      v-on:regresar="mostrarVisualizadorTesteoSentencia = false"
      :ref="'visorTesteoSentencia'">
    </VisorTesteoSentencia>
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import comun from "@/../static/js/comun"
  import api from '@/../static/js/api'
  import axios from 'axios'
  import FiltrosDeBusqueda from '@/components/SICSEN/Comun/FiltroDeBusqueda.vue'
  import TablaDeResultados from '@/components/SICSEN/Comun/TablaDeResultados.vue'
  import VisorTesteoSentencia from '@/components/SICSEN/Comun/VisorTesteoSentencia.vue'
  import catalogos from '../../../../static/js/api/SICUS/catalogos/catalogo'

  export default {
    components: {
      FiltrosDeBusqueda,
      TablaDeResultados,
      VisorTesteoSentencia
    },
    data(){
      return{
        keyVisor: 0,
        EsBase64:{},
        expediente: null,
        Sentencia:null,
        enumeraciones,
        esTesteo:false,
        mostrarVisualizadorTesteoSentencia: false,
        mostrarFormularioInformacionSentencia:false,        
        catalogos: [          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Sentencias' },          
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda-NoExtra-Sentencias' },
          { catalogoId: enumeraciones.catalogos.Delitos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Delito' },
          { catalogoId: enumeraciones.catalogos.Juicios, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Juicio' }
        ],
        elementosAOmitir: {
          materias: [8,10,11] //materias a omitir
        },
        AccionesTabla:{
            alta: false,
            altaBloqueda: false,
            baja: false,
            bajaBloqueda: false,
            cambios: false,
            cambiosBloquedo: false,
            consulta: true,
            visualizacion: true,
            visualizacionBloqueda: false,
            descargaWord: true
        },
        AccionesFormulario:{            
            administracion: false,
            consulta: true
        }              
      }
    },
    methods: {
      /** 
       * Método encargado de llamar API para búscar un expediente en base a los datos proporcionados.
       */
      buscarExpediente: function(evento) {         
        
        const parametros = {       
            PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId : null,               
            MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
            AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
            TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId : null,
            Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,
            NumeroDeDocumento: this.$store.state.Comun_NumeroExtra,
            EsPrueba: this.enumeraciones.EsPrueba,
            JuicioId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Juicio.juicioId) ? this.$refs['filtroBusqueda'].parametros_Juicio.juicioId : null,
            DelitoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Delito.delitoId) ? this.$refs['filtroBusqueda'].parametros_Delito.delitoId : null,
            TipoDeResolucionId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoResolucion.tipoResolucionId) ? this.$refs['filtroBusqueda'].parametros_TipoResolucion.tipoResolucionId : null,
            FechaDeDictadoInicial: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].fechaDeDictadoInicial) ? this.$refs['filtroBusqueda'].fechaDeDictadoInicial : null,
            FechaDeDictadoFinal: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].fechaDeDictadoFinal) ? this.$refs['filtroBusqueda'].fechaDeDictadoFinal : null,
            TodasLasSentenciasConPerspectiva: this.$refs['filtroBusqueda'].todasLasSentenciasMarcadasComoPerspectivaDeGenero,
            ClasificacionYCaracteristicasPerspectivaDeGenero: this.obtenerListadoDePerspectivaSeleccionados(this.$refs['filtroBusqueda'].clasificacionYCaracteristicasPerspectivaDeGenero, true),
            ConPerspectivaDeGenero: this.$refs['filtroBusqueda'].mostrarFiltradoPerspectivaDeGenero,
             /* SentenciaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].folioSentencia) ? this.$refs['filtroBusqueda'].folioSentencia : null,
              FechaDeRegistro: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].fechaDeSentencia) ? this.$refs['filtroBusqueda'].fechaDeSentencia : null
             */            
          }
        if(this.validarDatosBusquedaExpediente(parametros)){  
        comun.SeEstaCargandoInformacion(true);                
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        
          axios.post(api.conexion + api.SICSEN.sistema.consulta.consultaPublicaSentencias.ConsultaExpediente, parametros, headerPeticion)
          .then(respuesta => { 
            comun.SeEstaCargandoInformacion(false);                      
            if (respuesta.data.SiHayError) {              
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              if(!respuesta.data.Error.Mensaje.includes("500")){
                this.limpiarTablaResultados();
              }          
            } 
            if(respuesta.data.Expediente != null){
              //CargarDatos de expediente
              this.expediente = respuesta.data.Expediente;
            }
                       
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }        
      },
      /** 
       * Método encargado de verificar que todos los campos para la búsqueda estén llenos.
       * @param {object} datos [datos de filtro de búsqueda]
       */
      validarDatosBusquedaExpediente: function(datos){
          if ((datos.PartidoJudicialId == null || datos.PartidoJudicialId == -1) &&
              (datos.MateriaId == null || datos.MateriaId == -1) &&
              (datos.AreaId == null || datos.AreaId == -1) &&
              (datos.TipoDeDocumentoId == null || datos.TipoDeDocumentoId == -1) &&
              (datos.Consecutivo == null || datos.Consecutivo == undefined || datos.Consecutivo == "") &&
              (datos.TipoDeResolucionId == null || datos.TipoDeResolucionId == -1) &&
              (datos.FechaDeDictado == null || datos.FechaDeDictado == -1) &&
              (datos.FechaDeDictadoInicial == null || datos.FechaDeDictadoInicial == -1 || datos.FechaDeDictadoFinal == null || datos.FechaDeDictadoFinal == -1) &&
              (!(datos.ClasificacionYCaracteristicasPerspectivaDeGenero.length > 0) && !datos.TodasLasSentenciasConPerspectiva)
          ) {
            comun.mensajeDeAlerta("Favor de ingresar información.", null, null);
            return false;
          }          
         
          return true;
      }, 
      /** 
       * Metodo encargado de obtener listado de elementos seleccionados de perspectiva de género
       */
      obtenerListadoDePerspectivaSeleccionados:function(listado, listadoPadre)
      {
        listado = listado.map(a => Object.assign({}, a));
        return listado.filter(elemento => {                  
          if(elemento.Activo)
          {
            if(listadoPadre)
            {
              elemento.SentenciaCaracteristicasPerspectivaDeGenero = this.obtenerListadoDePerspectivaSeleccionados([...elemento.SentenciaCaracteristicasPerspectivaDeGenero], false)
              return elemento;
            }
            else return elemento;
          }
        })
      },
      /** 
       * Método encargado de verificar que el campo proporcionado tenga un valor valido.
       * @param {string/int/other} campo [campo]
       */
      campoRequeridoEsValido: function(campo) {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      /**
       * Método encargado de obtener la ruta del archivo PDF de la sentencia.
       */
      obtenerRutaArchivoFinal() {
          return this.$store.getters.Get_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal;
      },
      /** 
       * Método encargado de deshabilitar los componentes y reiniciar valores al momento de calcelar el alta o cambios de una sentencia.
       */
      cancelarAltaCambios:function(){
        this.mostrarVisualizadorTesteoSentencia = false;
        this.cambioRutaArchivoFinal(null);
        this.Sentencia = null;
      },
      /**
       * Método encargado de cambiar la ruta del archivo final (PDF).
       */
      cambioRutaArchivoFinal(ruta) {
        this.$store.dispatch("A_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal", ruta);
      },
      obtenerEsBase64() {
          return this.$store.getters.Get_SICSEN_Sentencias_EsBase64;
      },
      cambioEsBase64(EsBase64) {
        this.$store.dispatch("A_SICSEN_Sentencias_EsBase64", EsBase64);
      },
      /** 
       * Método encargado de asignar la Sentencia seleccionada para poder visualizarla en el visor en base a su ArchivoFinalRuta.
       * @param {object} datos [datos: Sentencia]
       */
      accionRealizar: async function(datos)
      { 
        this.Sentencia = datos.Sentencia;
        
        if(datos.Accion.DescargarWord && this.Sentencia.ExisteArchivoOrigen){              
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = `${api.conexion}${api.SICSEN.sistema.consulta.consultaPublicaSentencias.DescargaWord}?rutaDelArchivo=${ this.Sentencia.ArchivoOriginalRuta }`
          a.click();          
        }

        if(datos.Accion.Visualizar){
          this.cambioEsBase64(null);
          this.Sentencia = datos.Sentencia;        
          const parametros = { 
            ArchivoFinalRuta: this.Sentencia.ArchivoFinalRuta
          }
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);
          await axios.post(api.conexion + api.SICSEN.sistema.consulta.consultaPublicaSentencias.ConvierteBase64, parametros, headerPeticion)
            .then(respuesta => {                         
              if (respuesta.data.SiHayError) {              
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);      
              } 
              if(respuesta.data.ArchivoBase64 != null){              
                this.EsBase64={
                    esBase64: true,
                    archivoBase64: respuesta.data.ArchivoBase64
                  }    
                  this.cambioEsBase64(this.EsBase64);
                  //this.keyVisor += 1;                
                  this.esTesteo = false;
                  this.cambioRutaArchivoFinal(this.Sentencia.ArchivoFinalRuta);
                  this.mostrarVisualizadorTesteoSentencia = true;   
              }
                        
            })
            .catch(e => {
              console.log("No Hay Respuesta del Servidor" + e);
              comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },
      /**
       * Método encargado de limpiar/ocultar el componente de TablaDeResultados.
       */
      limpiarTablaResultados:function(){
        this.expediente = null;
      }    
    }
  }
</script>
<style scoped>
.gris-claro{
  background-color:var(--gris-pj-100) !important;
}
.areaLocal{
  background-color: var(--verde-pj-100);
  box-shadow: 0px 6px 20px 4px #161616;
  padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/SICSEN/Consulta/ConsultaPublicaSentencias.vue